export const NOISE_GLSL = `float hash21(vec2 point) {
  vec3 value = fract(vec3(point.xyx) * 0.1031);
  value += dot(value, value.yzx + 33.33);
  return fract((value.x + value.y) * value.z);
}

float valueNoise(vec2 point) {
  vec2 cell = floor(point);
  vec2 fraction = fract(point);
  fraction = fraction * fraction * (3.0 - 2.0 * fraction);
  return mix(
    mix(hash21(cell), hash21(cell + vec2(1.0, 0.0)), fraction.x),
    mix(
      hash21(cell + vec2(0.0, 1.0)),
      hash21(cell + vec2(1.0, 1.0)),
      fraction.x
    ),
    fraction.y
  );
}

float fbm(vec2 point) {
  float signal = 0.0;
  float amplitude = 0.5;
  for (int octave = 0; octave < 4; octave += 1) {
    signal += valueNoise(point) * amplitude;
    point = mat2(1.63, 1.18, -1.18, 1.63) * point + 4.17;
    amplitude *= 0.5;
  }
  return signal;
}

float hash31(vec3 point) {
  point = fract(point * 0.1031);
  point += dot(point, point.yzx + 33.33);
  return fract((point.x + point.y) * point.z);
}

float valueNoise3D(vec3 point) {
  vec3 cell = floor(point);
  vec3 fraction = fract(point);
  fraction = fraction * fraction * (3.0 - 2.0 * fraction);
  float lower = mix(
    mix(hash31(cell), hash31(cell + vec3(1.0, 0.0, 0.0)), fraction.x),
    mix(
      hash31(cell + vec3(0.0, 1.0, 0.0)),
      hash31(cell + vec3(1.0, 1.0, 0.0)),
      fraction.x
    ),
    fraction.y
  );
  float upper = mix(
    mix(
      hash31(cell + vec3(0.0, 0.0, 1.0)),
      hash31(cell + vec3(1.0, 0.0, 1.0)),
      fraction.x
    ),
    mix(
      hash31(cell + vec3(0.0, 1.0, 1.0)),
      hash31(cell + vec3(1.0, 1.0, 1.0)),
      fraction.x
    ),
    fraction.y
  );
  return mix(lower, upper, fraction.z);
}

float fbm3D(vec3 point) {
  float signal = 0.0;
  float amplitude = 0.5;
  for (int octave = 0; octave < 3; octave += 1) {
    signal += valueNoise3D(point) * amplitude;
    point = mat3(
      0.0, 0.8, 0.6,
      -0.8, 0.36, -0.48,
      -0.6, -0.48, 0.64
    ) * point * 2.03 + vec3(4.17, -2.31, 6.43);
    amplitude *= 0.5;
  }
  return signal;
}

`;
